// Alpine.js v3 component registration
function pageComponent(){
    return {
        init(){
            const anchor =  window.location.hash;
            if(anchor !== ""){
                const anchorElement = document.getElementById(anchor.replace('#',''));
                if(anchorElement){
                    anchorElement.scrollIntoView({behavior: 'smooth'});
                }

            }
        }
    }
}

// Register the component with Alpine.js
document.addEventListener('alpine:init', () => {
    window.Alpine.data('Page', pageComponent);
});
